import { CategoryDiagnose } from '../api/app-types/category-diagnose.app';

export const mockCategoryDiagnose: CategoryDiagnose = {
	id: 1,
	description: 'Category Diagnosis Description',
};

export const mockCategoryDiagnose2: CategoryDiagnose = {
	id: 2,
	description: 'Category Diagnosis Description 2',
};

export const mockCategoryDiagnoses: CategoryDiagnose[] = [mockCategoryDiagnose, mockCategoryDiagnose2];
